import DynamicAnalysisWorkspace from "../components/personal/main_page/DynamicAnalysisWorkspace";
import MainNavbar from "../components/reuse/navbar";

export default function DynamicAnalysisPage() {
  return (
    <>
      <div>
        <MainNavbar />
      </div>
      <DynamicAnalysisWorkspace />
    </>
  );
}
